/** Omits each entry whose value is `''`; an empty string means "absent" to a vendor prop. */
export const omitEmptyStringProps = <T extends Record<string, unknown>>(props: T): Partial<T> => {
  const result: Partial<T> = {}
  for (const key of Object.keys(props) as (keyof T)[]) {
    if (props[key] !== '') result[key] = props[key]
  }
  return result
}
